
































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";
import { PropOptions } from "vue";
import Miembro from "../../models/miembro/miembro.model";
import BTableConfig from "@/core/BTableConfig/BTableConfig";
import TramiteBeneficiario from "@/models/tramite/tramiteBeneficiario.model";
import TramiteCambioJefeHogar from "@/models/tramite/cambio-jefe-hogar/cambioJefeHogar.model";
import Persona from "@/models/persona/persona.model";
import Beneficiario from "@/models/beneficiario/beneficiario.model";
import TipoTramite from "@/models/tipoTramite";
import BaseHttpClient from "@/core/HttpResources/BaseHttpClient";
import { CambioJefeHogarRazon } from "@/enums/CambioJefeHogarRazon";

@Component({})
export default class CambioJefeHogarResumen extends BaseVue {
  @Prop() readonly tipoTramite!: TipoTramite;
  @Prop() readonly solicitante!: Persona;
  @Prop() readonly beneficiario!: Beneficiario;
  @Prop() readonly content!: TramiteBeneficiario;
  CambioJefeHogarRazon = CambioJefeHogarRazon;

  model: any = null;
  get hogarCode() {
    if (this.beneficiario && this.beneficiario.codigoHogar)
      return this.beneficiario.codigoHogar;
    return "";
  }
  get hogarId() {
    if (this.beneficiario && this.beneficiario.hogarId)
      return this.beneficiario.hogarId;
    return 0;
  }
    get jefeAnterior() {
    if (this.model) return this.model.jefeAnterior;
    return null;
  }
  get jefePropuesto() {
    if (this.model) return this.model.jefeHogar;
    return null;
  }
  get tramiteBeneficiarioId() {
    if (this.content && this.content.id) return this.content.id;
    if (this.$route.params.id) return this.$route.params.id;
    return 0;
  }

  async mounted() {
    if (this.tramiteBeneficiarioId) {
      this.model = await new BaseHttpClient(
        "TramiteBeneficiarioResumen"
      ).getAsync("GetCambioJefe", {
        tramiteId: this.tramiteBeneficiarioId
      });
    }
  }
}
